import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-star-icon',
	templateUrl: './star-icon.component.html',
})
export class StarIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
